import {useEffect, useState} from "react";
import {assignedRolesVar} from "../config/Cache";
import {CustomRoles} from "../helpers/CustomRoles";

export function usePermissions(currentUser) {
    const [canContentManage, setCanContentManage] = useState();
    const [canTrafficManage, setCanTrafficManage] = useState();
    const [canAdmin, setCanAdmin] = useState();
    const [canTeach, setCanTeach] = useState();
    const [canCustomerSupport, setCanCustomerSupport] = useState();
    const [canLiveOps, setCanLiveOps] = useState();
    const [canQA, setCanQA] = useState();

    useEffect(() => {
        if (!currentUser) {
            return;
        }

        const assignedRoles = assignedRolesVar();

        setCanAdmin(assignedRoles.indexOf(CustomRoles.Admin) > -1);
        setCanContentManage(assignedRoles.indexOf(CustomRoles.ContentManager) > -1);
        setCanTrafficManage(assignedRoles.indexOf(CustomRoles.TrafficManager) > -1);
        setCanTeach(assignedRoles.indexOf(CustomRoles.Teacher) > -1);
        setCanCustomerSupport(assignedRoles.indexOf(CustomRoles.CustomerSupport) > -1);
        setCanQA(assignedRoles.indexOf(CustomRoles.QA) > -1);
        setCanLiveOps(assignedRoles.indexOf(CustomRoles.LiveOperations) > -1);
    }, [currentUser]);

    return {canContentManage, canTrafficManage, canAdmin, canTeach, canCustomerSupport, canLiveOps, canQA};
}